<script type="ts">
	export let text: string;
	export let style: "separator" | "unread" = "separator";
</script>

<div class="hr {style}">{text}</div>

<style>
	.hr {
		margin: 0.5rem 0;
		padding: 0.5rem;
		border-bottom: hsl(0 0% 0% / 0.085) 2px solid;
		text-align: center;
		font-weight: 600;
		color: var(--demo-bg-60);
		font-size: 0.66rem;
	}
	.unread {
		border-color: currentColor;
		color: var(--code-text);
		text-align: left;
		font-weight: 300;
		border-width: 1px;
	}
</style>